import { BrowserRouter, Routes, Route } from "react-router-dom";
import { StyleProvider, ThemeProvider } from "vcc-ui";
import { Tyres } from "./Tyres";
import volvo from "vcc-ui/dist/themes/volvo";

const pathPrefix = "https://pkgs.gvcs.fbinhouse.se/vcc-ui/1.2.1/assets";

export const App = () => {
    return (
        <StyleProvider>
            <ThemeProvider
                theme={{
                    ...volvo,
                    fontsPath: pathPrefix + "/fonts/",
                    logoImagesPath: pathPrefix + "/images/",
                }}
            >
                <BrowserRouter>
                    <Routes>
                        <Route path="/:branchCode/*" element={<Tyres />} />
                    </Routes>
                </BrowserRouter>
            </ThemeProvider>
        </StyleProvider>
    );
};